import React from "react";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("ra_token");
  const user = JSON.parse(localStorage.getItem("ra_user") || "null");

  if (!token) return <Navigate to="/login" replace />;

  // Client users don't belong in the admin layout — bounce them to their portal
  if (user?.role === "client" && user?.client_id) {
    // We don't have the slug in the user payload, so /login will resolve via portal
    // Easier: just kick them to /login and ProtectedRoute will retry until a slug is available.
    // Since clients always come in via /portal/:slug/login, this branch only triggers if they
    // hand-type an admin URL — kick to /login (admin) which they can't pass anyway.
    localStorage.removeItem("ra_token");
    localStorage.removeItem("ra_user");
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
